import React from "react";
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Spacer,
  Text,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Link,
  Select,
  Checkbox,
  background,
  useToast,
} from "@chakra-ui/react";

// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import GradientBorder from "components/GradientBorder/GradientBorder";

import { useLoader } from "components/Loader/loader";

function PaymentPricing() {
  const titleColor = "white";
  const toast = useToast();

  const { setIsLoading, isLoading } = useLoader();

  const [formData, setFormData] = React.useState({
    pr_price: "",
    analytics_price: "",
    print_price: "",
    est_reader: "",
    discount_rate: "",
    discount_pr: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // if (name === "advertiser") {
    //   fetchOrders({
    //     advertiser_uuid: value,
    //     payment: "True",
    //   });
    // }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      pr_price: formData.pr_price,
      analytic_price: formData.analytics_price,
      print_price: formData.print_price,
      est_reader: formData.est_reader,
      discount_rate: formData.discount_rate,
      discount_on_pr: formData.discount_pr,
    };
    console.log(data);

    // createPayment(data);
  };

  if (isLoading) {
    return <div></div>;
  }

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }} mx="auto">
      {/* Form */}
      <Card p="16px">
        <CardHeader>
          <Flex
            justify="space-between"
            align="center"
            minHeight="60px"
            w="100%"
          >
            <Text fontSize="lg" color="#fff" fontWeight="bold">
              Payment Pricing
            </Text>
          </Flex>
        </CardHeader>
        <CardBody>
          <Flex
            justify="space-between"
            align="center"
            minHeight="60px"
            w="70%"
            mx="auto"
          >
            <GradientBorder
              p="2px"
              ml={{ base: "0px", lg: "24px" }}
              w="100%"
              me={{ base: "none", lg: "30px", xl: "none" }}
              background="transparent"
              boxShadow="0px 0px 2px 2px rgba(255,255,255,0.1)"
              borderRadius="30px"
            >
              <Flex
                background="transparent"
                borderRadius="30px"
                direction="column"
                p="40px"
                minW={{ base: "unset", md: "430px", xl: "450px" }}
                w="100%"
                mx={{ base: "0px" }}
                bg={{
                  base: "rgba(19,21,56,.5)",
                }}
              >
                <form onSubmit={handleSubmit}>
                  <FormControl>
                    <FormLabel
                      color={titleColor}
                      ms="4px"
                      fontSize="sm"
                      fontWeight="normal"
                    >
                      PR Price
                    </FormLabel>
                    <GradientBorder
                      mb="24px"
                      h="50px"
                      w={{ base: "100%", lg: "100%" }}
                      borderRadius="20px"
                    >
                      <Input
                        color={titleColor}
                        bg={{
                          base: "rgb(19,21,54)",
                        }}
                        border="transparent"
                        borderRadius="20px"
                        fontSize="sm"
                        size="lg"
                        w={{ base: "100%", lg: "100%" }}
                        maxW="100%"
                        h="46px"
                        type="text"
                        placeholder="PR Price"
                        name="pr_price"
                        value={formData.pr_price}
                        onChange={handleChange}
                      />
                    </GradientBorder>
                    <FormLabel
                      color={titleColor}
                      ms="4px"
                      fontSize="sm"
                      fontWeight="normal"
                    >
                      Analytics Price
                    </FormLabel>
                    <GradientBorder
                      mb="24px"
                      h="50px"
                      w={{ base: "100%", lg: "100%" }}
                      borderRadius="20px"
                    >
                      <Input
                        color={titleColor}
                        bg={{
                          base: "rgb(19,21,54)",
                        }}
                        border="transparent"
                        borderRadius="20px"
                        fontSize="sm"
                        size="lg"
                        w={{ base: "100%", lg: "100%" }}
                        maxW="100%"
                        h="46px"
                        type="text"
                        placeholder="Analytics Price"
                        name="analytics_price"
                        value={formData.analytics_price}
                        onChange={handleChange}
                      />
                    </GradientBorder>
                    <FormLabel
                      color={titleColor}
                      ms="4px"
                      fontSize="sm"
                      fontWeight="normal"
                    >
                      Print Price
                    </FormLabel>
                    <GradientBorder
                      mb="24px"
                      h="50px"
                      w={{ base: "100%", lg: "100%" }}
                      borderRadius="20px"
                    >
                      <Input
                        color={titleColor}
                        bg={{
                          base: "rgb(19,21,54)",
                        }}
                        border="transparent"
                        borderRadius="20px"
                        fontSize="sm"
                        size="lg"
                        w={{ base: "100%", lg: "100%" }}
                        maxW="100%"
                        h="46px"
                        type="text"
                        placeholder="Print Price"
                        name="print_price"
                        value={formData.print_price}
                        onChange={handleChange}
                      />
                    </GradientBorder>
                    <FormLabel
                      color={titleColor}
                      ms="4px"
                      fontSize="sm"
                      fontWeight="normal"
                    >
                      Estimated Reader
                    </FormLabel>
                    <GradientBorder
                      mb="24px"
                      h="50px"
                      w={{ base: "100%", lg: "100%" }}
                      borderRadius="20px"
                    >
                      <Input
                        color={titleColor}
                        bg={{
                          base: "rgb(19,21,54)",
                        }}
                        border="transparent"
                        borderRadius="20px"
                        fontSize="sm"
                        size="lg"
                        w={{ base: "100%", lg: "100%" }}
                        maxW="100%"
                        h="46px"
                        type="text"
                        placeholder="Estimated Reader"
                        name="est_reader"
                        value={formData.est_reader}
                        onChange={handleChange}
                      />
                    </GradientBorder>
                    <FormLabel
                      color={titleColor}
                      ms="4px"
                      fontSize="sm"
                      fontWeight="normal"
                    >
                      Discount Rate (%)
                    </FormLabel>
                    <GradientBorder
                      mb="24px"
                      h="50px"
                      w={{ base: "100%", lg: "100%" }}
                      borderRadius="20px"
                    >
                      <Input
                        color={titleColor}
                        bg={{
                          base: "rgb(19,21,54)",
                        }}
                        border="transparent"
                        borderRadius="20px"
                        fontSize="sm"
                        size="lg"
                        w={{ base: "100%", lg: "100%" }}
                        maxW="100%"
                        h="46px"
                        type="text"
                        placeholder="Discount Rate (%)"
                        name="discount_rate"
                        value={formData.discount_rate}
                        onChange={handleChange}
                      />
                    </GradientBorder>
                    <FormLabel
                      color={titleColor}
                      ms="4px"
                      fontSize="sm"
                      fontWeight="normal"
                    >
                      Discount on PR
                    </FormLabel>
                    <GradientBorder
                      mb="24px"
                      h="50px"
                      w={{ base: "100%", lg: "100%" }}
                      borderRadius="20px"
                    >
                      <Input
                        color={titleColor}
                        bg={{
                          base: "rgb(19,21,54)",
                        }}
                        border="transparent"
                        borderRadius="20px"
                        fontSize="sm"
                        size="lg"
                        w={{ base: "100%", lg: "100%" }}
                        maxW="100%"
                        h="46px"
                        type="text"
                        placeholder="Discount on PR"
                        name="discount_pr"
                        value={formData.discount_pr}
                        onChange={handleChange}
                      />
                    </GradientBorder>
                    <Button
                      variant="brand"
                      fontSize="1.2rem"
                      type="submit"
                      w={{ base: "100%", lg: "100%" }}
                      maxW="100%"
                      h="45px"
                      mb="20px"
                      mt="20px"
                    >
                      Submit
                    </Button>
                  </FormControl>
                </form>
              </Flex>
            </GradientBorder>
          </Flex>
        </CardBody>
      </Card>
    </Flex>
  );
}

export default PaymentPricing;
